import React from 'react'
import Embed from './Embed'

export default ({ url }) => (
  <Embed>
    <iframe src={`https://www.youtube.com/embed/${url}?rel=0&showinfo=0`} frameBorder="0"
            allowFullScreen></iframe>
  </Embed>
)



/** WEBPACK FOOTER **
 ** ./src/components/YoutubeEmbed.js
 **/